import Container from "@mui/material/Container";

export default function Layout({ children }) {
  return (
    <Container maxWidth="lg" className="theme">
      {children}
    </Container>
  );
}
